import { useQuery } from '@tanstack/react-query';
import { useAuthContext } from '@/context/AuthContext.tsx';
import userRepository from '@/api/repositories/userRepository/UserRepository.ts';
import type { User } from '$/models/User';

const useCurrentUser = () => {
  const { session } = useAuthContext();
  const authId = session?.user?.id;

  const queryKey = ['current-user', authId ?? 'no-auth'];

  const queryFn = async (): Promise<User | null> => {
    if (!authId) return null;
    const { data, error } = await userRepository.findOne({ auth_id: authId });
    if (error) throw new Error(error.message);
    return data ?? null;
  };

  return useQuery({
    queryKey,
    queryFn,
    enabled: !!authId,
    staleTime: 1000 * 60,
  });
};

export default useCurrentUser;


